/* ============================================================
   Glaring Rugs — Three Column Product Section
   Self-contained. No dependency on Trade theme JavaScript.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- money formatting ---------- */
  function formatMoney(cents, format) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var fmt = format || '${{amount}}';

    function withCommas(num, precision, thousands, decimal) {
      var n = (num / 100.0).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }

    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    var value;

    switch (placeholder) {
      case 'amount_no_decimals':
        value = withCommas(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withCommas(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withCommas(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = withCommas(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withCommas(cents, 0, ' ', ',');
        break;
      default:
        value = withCommas(cents, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- parse a size string like 8x10 or 2'6x10 into square feet ---------- */
  function squareFeet(text) {
    if (!text) return 0;
    var cleaned = String(text).replace(/ft|feet|”|"/gi, '').trim();
    /* Round and square sizes such as "6 Round" or "6 Square" are priced on the full square */
    var single = cleaned.match(/^(\d+(?:\.\d+)?)\s*['’]?\s*(\d+(?:\.\d+)?)?\s*(round|square|circle)$/i);
    if (single) {
      var side = parseFloat(single[1]) + (parseFloat(single[2] || 0) / 12);
      return side * side;
    }
    var parts = cleaned.split(/\s*[x×]\s*/i);
    if (parts.length !== 2) return 0;

    function toFeet(part) {
      part = part.trim();
      var feetInch = part.match(/^(\d+(?:\.\d+)?)\s*['’]\s*(\d+(?:\.\d+)?)?$/);
      if (feetInch) {
        return parseFloat(feetInch[1]) + (parseFloat(feetInch[2] || 0) / 12);
      }
      var n = parseFloat(part);
      return isNaN(n) ? 0 : n;
    }

    var a = toFeet(parts[0]);
    var b = toFeet(parts[1]);
    return a > 0 && b > 0 ? a * b : 0;
  }

  /* ============================================================ */
  function ThreeColumnProduct(root) {
    this.root = root;
    this.moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    this.addLabel = root.dataset.addLabel || 'Add to cart';
    this.cartAddUrl = root.dataset.cartAddUrl || '/cart/add';
    this.cartUrl = root.dataset.cartUrl || '/cart';
    this.showUnit = root.dataset.unitPrice === 'true';
    this.unitOption = (root.dataset.unitOption || 'size').toLowerCase();

    this.form = root.querySelector('form[action*="/cart/add"]');
    this.idInput = root.querySelector('[data-variant-id]');
    this.priceEl = root.querySelector('[data-price]');
    this.compareEl = root.querySelector('[data-compare]');
    this.saveEl = root.querySelector('[data-save]');
    this.savePctEl = root.querySelector('[data-save-pct]');
    this.summaryEl = root.querySelector('[data-summary]');
    this.addBtn = root.querySelector('[data-add]');
    this.addText = root.querySelector('[data-add-text]');
    this.spinner = root.querySelector('[data-spinner]');
    this.errorEl = root.querySelector('[data-form-error]');
    this.qtyInput = root.querySelector('[data-qty]');
    this.toastEl = root.querySelector('[data-toast]');
    this.mbPrice = root.querySelector('[data-mb-price]');
    this.mbSub = root.querySelector('[data-mb-sub]');
    this.stockPill = root.querySelector('[data-stock-pill]');
    this.salePill = root.querySelector('[data-sale-pill]');

    var json = root.querySelector('[data-variant-json]');
    this.variants = [];
    if (json) {
      try {
        this.variants = JSON.parse(json.textContent);
      } catch (e) {
        this.variants = [];
      }
    }

    this.optionNames = [];
    var wraps = root.querySelectorAll('[data-option-wrap]');
    for (var i = 0; i < wraps.length; i++) {
      var lbl = wraps[i].querySelector('.gr3-opt-label');
      this.optionNames.push(lbl ? lbl.textContent.replace(/required/i, '').trim() : '');
    }

    var optionsEl = root.querySelector('[data-options]');
    this.hideMissing = !optionsEl || optionsEl.dataset.hideMissing !== 'false';
    this.initGallery();
    this.initOptions();
    this.initQuantity();
    this.initCart();
    this.update();
  }

  /* ---------------- gallery ---------------- */
  ThreeColumnProduct.prototype.initGallery = function () {
    var self = this;
    this.slides = Array.prototype.slice.call(this.root.querySelectorAll('[data-slide]'));
    this.thumbs = Array.prototype.slice.call(this.root.querySelectorAll('[data-thumb]'));
    this.counter = this.root.querySelector('[data-counter]');
    this.index = 0;
    if (!this.slides.length) return;

    this.thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        self.goTo(i);
      });
    });

    var prev = this.root.querySelector('[data-prev]');
    var next = this.root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.goTo(self.index + 1); });

    var stage = this.root.querySelector('[data-stage]');
    if (stage) {
      var startX = null;
      stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 45) self.goTo(self.index + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });
    }
  };

  ThreeColumnProduct.prototype.goTo = function (i) {
    if (!this.slides.length) return;
    this.index = (i + this.slides.length) % this.slides.length;
    for (var s = 0; s < this.slides.length; s++) {
      this.slides[s].classList.toggle('is-active', s === this.index);
    }
    for (var t = 0; t < this.thumbs.length; t++) {
      this.thumbs[t].setAttribute('aria-selected', t === this.index ? 'true' : 'false');
    }
    if (this.counter) this.counter.textContent = this.index + 1 + ' / ' + this.slides.length;
  };

  ThreeColumnProduct.prototype.showMedia = function (mediaId) {
    if (!mediaId) return;
    for (var i = 0; i < this.slides.length; i++) {
      if (String(this.slides[i].dataset.mediaId) === String(mediaId)) {
        this.goTo(i);
        return;
      }
    }
  };

  /* ---------------- options ---------------- */
  ThreeColumnProduct.prototype.initOptions = function () {
    var self = this;

    this.root.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable') && btn.dataset.soldOut === 'true') {
          // still selectable so the shopper can see it is sold out
        }
        var pos = btn.dataset.position;
        self.root
          .querySelectorAll('[data-option-value][data-position="' + pos + '"]')
          .forEach(function (sib) {
            sib.setAttribute('aria-checked', sib === btn ? 'true' : 'false');
          });
        self.update();
      });
    });

    this.root.querySelectorAll('[data-option-select]').forEach(function (sel) {
      sel.addEventListener('change', function () { self.update(); });
    });

    var single = this.root.querySelector('[data-single-variant-select]');
    if (single) {
      single.addEventListener('change', function () {
        var opt = single.options[single.selectedIndex];
        self.priceEl.textContent = formatMoney(parseInt(opt.dataset.price, 10), self.moneyFormat);
        var cmp = parseInt(opt.dataset.compare, 10) || 0;
        self.setCompare(cmp, parseInt(opt.dataset.price, 10));
        if (self.mbPrice) self.mbPrice.textContent = self.priceEl.textContent;
      });
    }
  };

  ThreeColumnProduct.prototype.selectedValues = function () {
    var values = [];
    var wraps = this.root.querySelectorAll('[data-option-wrap]');
    for (var i = 0; i < wraps.length; i++) {
      var sel = wraps[i].querySelector('[data-option-select]');
      if (sel) {
        values.push(sel.value || null);
      } else {
        var checked = wraps[i].querySelector('[data-option-value][aria-checked="true"]');
        values.push(checked ? checked.dataset.value : null);
      }
    }
    return values;
  };

  ThreeColumnProduct.prototype.matchVariant = function (values) {
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i];
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] === null) { ok = false; break; }
        var opt = v['option' + (j + 1)];
        if (opt !== values[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  };

  /* Does any variant exist with the earlier options as selected and this value? */
  ThreeColumnProduct.prototype.valueExists = function (values, index, val) {
    return this.variants.some(function (v) {
      for (var j = 0; j < index; j++) {
        if (values[j] !== null && v['option' + (j + 1)] !== values[j]) return false;
      }
      return v['option' + (index + 1)] === val;
    });
  };

  /* After a shape change, move any selection that no longer exists to the first valid value */
  ThreeColumnProduct.prototype.ensureValidSelection = function () {
    var self = this;
    var wraps = this.root.querySelectorAll('[data-option-wrap]');
    var values = this.selectedValues();
    wraps.forEach(function (wrap, i) {
      if (i === 0) return;
      if (values[i] !== null && self.valueExists(values, i, values[i])) return;
      var sel = wrap.querySelector('[data-option-select]');
      var candidates = sel
        ? Array.prototype.map.call(sel.options, function (o) { return o.value; }).filter(Boolean)
        : Array.prototype.map.call(wrap.querySelectorAll('[data-option-value]'), function (b) { return b.dataset.value; });
      var valid = candidates.filter(function (c) { return self.valueExists(values, i, c); });
      if (!valid.length) return;
      var pick = valid[0];
      for (var k = 0; k < valid.length; k++) {
        var test = values.slice();
        test[i] = valid[k];
        var ok = self.variants.some(function (v) {
          for (var j = 0; j <= i; j++) {
            if (test[j] !== null && v['option' + (j + 1)] !== test[j]) return false;
          }
          return v.available;
        });
        if (ok) { pick = valid[k]; break; }
      }
      values[i] = pick;
      if (sel) {
        sel.value = pick;
      } else {
        wrap.querySelectorAll('[data-option-value]').forEach(function (b) {
          b.setAttribute('aria-checked', b.dataset.value === pick ? 'true' : 'false');
        });
      }
    });
  };

  /* Mark option values that cannot be combined with the current selection */
  ThreeColumnProduct.prototype.refreshAvailability = function (values) {
    var self = this;
    var wraps = this.root.querySelectorAll('[data-option-wrap]');

    wraps.forEach(function (wrap, wIndex) {
      var candidates = wrap.querySelectorAll('[data-option-value], option');
      candidates.forEach(function (el) {
        var val = el.dataset ? el.dataset.value : null;
        if (val == null) val = el.value;
        if (!val) return;

        var test = values.slice();
        test[wIndex] = val;

        var possible = self.variants.some(function (v) {
          for (var j = 0; j < test.length; j++) {
            if (j === wIndex) {
              if (v['option' + (j + 1)] !== test[j]) return false;
            } else if (test[j] !== null && v['option' + (j + 1)] !== test[j]) {
              return false;
            }
          }
          return v.available;
        });

        /* Never strike through the value the shopper currently has selected —
           the buy button already communicates that combination is sold out. */
        var isCurrent = values[wIndex] === val;
        var exists = wIndex === 0 || self.valueExists(values, wIndex, val);
        if (self.hideMissing) el.hidden = !exists;

        if (el.tagName === 'OPTION') {
          el.disabled = !possible && !isCurrent;
          var base = el.textContent.replace(/ — sold out$/i, '');
          el.textContent = possible || isCurrent ? base : base + ' — sold out';
        } else {
          el.classList.toggle('is-unavailable', !possible && !isCurrent);
          el.dataset.soldOut = possible ? 'false' : 'true';
        }
      });
    });
  };

  /* Show a per-square-foot rate on the wool / material cards */
  ThreeColumnProduct.prototype.refreshCardRates = function (values) {
    if (!this.showUnit) return;
    var self = this;
    var sizeIndex = -1;
    for (var i = 0; i < this.optionNames.length; i++) {
      if (this.optionNames[i].toLowerCase() === this.unitOption) sizeIndex = i;
    }
    if (sizeIndex === -1 || !values[sizeIndex]) return;
    var area = squareFeet(values[sizeIndex]);
    if (!area) return;

    this.root.querySelectorAll('[data-card-rate]').forEach(function (span) {
      var btn = span.closest('[data-option-value]');
      if (!btn) return;
      var wrapIndex = Array.prototype.indexOf.call(
        self.root.querySelectorAll('[data-option-wrap]'),
        btn.closest('[data-option-wrap]')
      );
      var test = values.slice();
      test[wrapIndex] = btn.dataset.value;
      var v = self.matchVariant(test);
      span.textContent = v ? formatMoney(Math.round(v.price / area), self.moneyFormat) + ' / sq ft' : '';
    });
  };

  /* ---------------- quantity ---------------- */
  ThreeColumnProduct.prototype.initQuantity = function () {
    var self = this;
    var minus = this.root.querySelector('[data-qty-minus]');
    var plus = this.root.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { self.bumpQty(-1); });
    if (plus) plus.addEventListener('click', function () { self.bumpQty(1); });
    if (this.qtyInput) this.qtyInput.addEventListener('change', function () { self.update(); });
  };

  ThreeColumnProduct.prototype.bumpQty = function (delta) {
    if (!this.qtyInput) return;
    var n = parseInt(this.qtyInput.value, 10) || 1;
    this.qtyInput.value = Math.max(1, n + delta);
    this.update();
  };

  /* ---------------- render ---------------- */
  ThreeColumnProduct.prototype.setCompare = function (compare, price) {
    if (!this.compareEl) {
      if (this.saveEl) this.saveEl.hidden = !(compare && compare > price);
      return;
    }
    if (compare && compare > price) {
      this.compareEl.textContent = formatMoney(compare, this.moneyFormat);
      this.compareEl.hidden = false;
      if (this.saveEl) {
        this.saveEl.hidden = false;
        this.savePctEl.textContent = Math.round(((compare - price) / compare) * 100) + '% off';
      }
    } else {
      this.compareEl.hidden = true;
      if (this.saveEl) this.saveEl.hidden = true;
    }
  };

  ThreeColumnProduct.prototype.update = function () {
    if (!this.variants.length) return;

    this.ensureValidSelection();
    var values = this.selectedValues();
    this.refreshAvailability(values);
    this.refreshCardRates(values);

    var variant = this.matchVariant(values);
    var qty = this.qtyInput ? Math.max(1, parseInt(this.qtyInput.value, 10) || 1) : 1;

    if (!variant) {
      var cheapest = this.variants.reduce(function (a, b) { return b.price < a.price ? b : a; });
      this.priceEl.textContent = 'From ' + formatMoney(cheapest.price, this.moneyFormat);
      this.setCompare(0, 0);
      if (this.summaryEl) {
        this.summaryEl.innerHTML = 'Choose your options above to see the exact price.';
      }
      if (this.idInput) this.idInput.value = '';
      if (this.addBtn) {
        this.addBtn.disabled = true;
        this.addText.textContent = 'Select options';
      }
      if (this.mbPrice) this.mbPrice.textContent = this.priceEl.textContent;
      if (this.mbSub) this.mbSub.textContent = 'Select options';
      if (this.stockPill) this.stockPill.hidden = true;
      if (this.salePill) this.salePill.hidden = true;
      return;
    }

    var total = variant.price * qty;
    var compareTotal = variant.compare_at_price ? variant.compare_at_price * qty : 0;

    this.priceEl.textContent = formatMoney(total, this.moneyFormat);
    this.setCompare(compareTotal, total);

    if (this.idInput) this.idInput.value = variant.id;

    if (this.addBtn) {
      this.addBtn.disabled = !variant.available;
      this.addText.textContent = variant.available ? this.addLabel : 'Sold out';
    }

    /* summary line */
    if (this.summaryEl) {
      var bits = ['<strong>' + variant.title.replace(/ \/ /g, ' · ') + '</strong>'];
      if (this.showUnit) {
        var sizeIndex = -1;
        for (var i = 0; i < this.optionNames.length; i++) {
          if (this.optionNames[i].toLowerCase() === this.unitOption) sizeIndex = i;
        }
        var area = sizeIndex > -1 ? squareFeet(values[sizeIndex]) : 0;
        if (area) {
          bits.push(
            area.toFixed(1) + ' sq ft at ' +
            formatMoney(Math.round(variant.price / area), this.moneyFormat) + ' / sq ft'
          );
        }
      }
      if (qty > 1) bits.push(qty + ' pieces');
      if (variant.sku) bits.push('SKU ' + variant.sku);
      this.summaryEl.innerHTML = bits.join('<br>');
    }

    /* sale pill */
    if (this.salePill) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        this.salePill.hidden = false;
        this.salePill.textContent =
          Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) + '% off';
      } else {
        this.salePill.hidden = true;
      }
    }

    /* mobile bar */
    if (this.mbPrice) this.mbPrice.textContent = formatMoney(total, this.moneyFormat);
    if (this.mbSub) this.mbSub.textContent = variant.title.replace(/ \/ /g, ' · ');

    /* swap image + url */
    if (variant.featured_media && variant.featured_media.id) {
      this.showMedia(variant.featured_media.id);
    }
    if (window.history && window.history.replaceState && this.root.dataset.url) {
      window.history.replaceState({}, '', this.root.dataset.url + '?variant=' + variant.id);
    }
  };

  /* ---------------- cart ---------------- */
  ThreeColumnProduct.prototype.initCart = function () {
    var self = this;
    if (!this.form) return;

    this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.addToCart();
    });

    var mbAdd = this.root.querySelector('[data-mb-add]');
    if (mbAdd) {
      mbAdd.addEventListener('click', function () {
        if (self.addBtn && self.addBtn.disabled) {
          var firstEmpty = self.root.querySelector('[data-option-select]');
          if (firstEmpty) {
            firstEmpty.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstEmpty.focus();
          }
          self.toast('Please choose your options first');
          return;
        }
        self.addToCart();
      });
    }
  };

  ThreeColumnProduct.prototype.addToCart = function () {
    var self = this;
    if (!this.idInput || !this.idInput.value) {
      this.toast('Please choose your options first');
      return;
    }

    this.addBtn.disabled = true;
    if (this.spinner) this.spinner.hidden = false;
    if (this.errorEl) this.errorEl.hidden = true;

    var body = new FormData(this.form);

    fetch(this.cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          throw new Error(data.description || data.message || 'Could not add to cart');
        }
        self.toast('Added to cart');
        document.dispatchEvent(new CustomEvent('gr3:added', { detail: data }));
        /* Nudge the Trade theme cart drawer / bubble to refresh */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (typeof window.fetchCart === 'function') window.fetchCart();
        var bubble = document.querySelector('cart-drawer, #cart-notification, .cart-count-bubble');
        if (!bubble) window.location.href = self.cartUrl;
      })
      .catch(function (err) {
        if (self.errorEl) {
          self.errorEl.textContent = err.message;
          self.errorEl.hidden = false;
        }
        self.toast(err.message);
      })
      .finally(function () {
        self.addBtn.disabled = false;
        if (self.spinner) self.spinner.hidden = true;
      });
  };

  /* ---------------- toast ---------------- */
  ThreeColumnProduct.prototype.toast = function (msg) {
    if (!this.toastEl) return;
    var self = this;
    this.toastEl.textContent = msg;
    this.toastEl.classList.add('is-visible');
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(function () {
      self.toastEl.classList.remove('is-visible');
    }, 2800);
  };

  /* ---------------- boot ---------------- */
  function boot(scope) {
    (scope || document).querySelectorAll('[data-gr3-root]').forEach(function (el) {
      if (el.__gr3) return;
      el.__gr3 = new ThreeColumnProduct(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:select', function (e) { boot(e.target); });
})();
